export default __webpack_public_path__ + "static/signature-team-jacob-0d5a0c13690c0581d9dc33fb68f124c1.png";